import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import React from 'react';

import { Link } from 'react-router-dom';

import { FlexRow, FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import SmartFillIcon from '../../../../configure-shipment/icons/smartfill_icon.svg';

import messages from './messages';
import style from './style.module.less';

export const SmartFillBanner = () => {
  return (
    <FlexRow className={style['smart-fill-banner-border']}>
      <FlexRow className={style['smart-fill-banner-content']}>
        <FlexColumn className={style['smart-fill-left-banner-content']}>
          <FlexRow className={style['smart-fill-left-banner-row']}>
            <img alt='' className={style['smart-fill-banner-icon']} src={SmartFillIcon} />
            <Text textType={TextType.Label} value={messages.smartFillApplied} />
          </FlexRow>
        </FlexColumn>
        <FlexColumn className={style['smart-fill-right-banner-content']}>
          <Link className={style['smart-fill-settings-link']} to='/settings/smartfillrules'>
            <Text textType={TextType.Paragraph} value={messages.manageSettings} />
            <FontAwesomeIcon className={style['right-arrow-icon']} icon={faArrowRight} />
          </Link>
        </FlexColumn>
      </FlexRow>
    </FlexRow>
  );
};
